module.exports = __webpack_public_path__ + "fonts/GlacialIndifference.e648fb0f.woff2";